import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './app/store';
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
  gtmId: 'GTM-W26HRQH'
}

TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter  >
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
)

reportWebVitals();
